import { render, staticRenderFns } from "@/manager/budget/views/budget-row/budget-fees/budget-fees.pug?vue&type=template&id=6f188210&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/manager/budget/views/budget-row/budget-fees/budget-fees.scss?vue&type=style&index=0&id=6f188210&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f188210",
  null
  
)

export default component.exports